<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluation/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>